module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ef.3c67fdaa.png";